const Timeline = () => {

  const button = document.querySelectorAll('.timeline .nav-list button')

  button.forEach(el => {
    el.addEventListener('click', function (event) {
      event.preventDefault()
      const id = this.dataset.item

      document.querySelector('.nav-list .active').classList.remove('active')
      document.querySelector('.items .active').classList.remove('active')

      document.getElementById(id).classList.add('active')

      this.classList.add('active')
    })
  })

  const buttonNextControl = document.querySelectorAll('.slider-control .slider-button-next')
  const buttonPrevControl = document.querySelectorAll('.slider-control .slider-button-prev')
  const navList = document.querySelector('.nav-list .list')
  
  buttonNextControl.forEach(el => {
    el.addEventListener('click', function (event) {
      event.preventDefault()
      
      let activeItem = document.querySelector('.nav-list .active')
      let nextItem = activeItem.nextElementSibling

      if(nextItem){
        nextItem.classList.add('active')
        activeItem.classList.remove('active')
        
        let scrollToSize = nextItem.offsetTop || nextItem
        
        navList.scroll({
          top: scrollToSize,
          behavior: 'smooth'
        });

        const id = nextItem.dataset.item
        document.querySelector('.items .active').classList.remove('active')
        document.getElementById(id).classList.add('active')
      }
    })
  })

  buttonPrevControl.forEach(el => {
    el.addEventListener('click', function (event) {
      event.preventDefault()
      
      let activeItem = document.querySelector('.nav-list .active')
      let nextItem = activeItem.previousElementSibling

      if(nextItem){
        nextItem.classList.add('active')
        activeItem.classList.remove('active')
        
        let scrollToSize = nextItem.offsetTop || nextItem
        
        navList.scroll({
          top: scrollToSize,
          behavior: 'smooth'
        });

        const id = nextItem.dataset.item
        document.querySelector('.items .active').classList.remove('active')

        document.getElementById(id).classList.add('active')
      }
    })
  })
}

export default Timeline
